/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function TrashCircleFill({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><rect width={16} height={16} fill="currentColor" rx={8} /><g fill="#fff" clipPath="url(#TrashCircleFill_svg__a)"><path d="M6.906 6.688c.207 0 .375.167.375.375v3.125a.375.375 0 0 1-.75 0V7.062c0-.207.168-.375.375-.375M9.469 7.063a.375.375 0 1 0-.75 0v3.125a.375.375 0 0 0 .75 0z" /><path fillRule="evenodd" d="M6.834 3.25a1 1 0 0 0-.936.647l-.345.916H3.625a.375.375 0 1 0 0 .75h.594l.496 5.703c.073.84.776 1.484 1.619 1.484h3.332c.843 0 1.546-.645 1.62-1.484l.495-5.703h.594a.375.375 0 0 0 0-.75h-1.934l-.373-.934a1 1 0 0 0-.929-.629zm3.345 2.313h.849l-.49 5.638a.875.875 0 0 1-.872.799H6.334a.875.875 0 0 1-.872-.8l-.49-5.637h5.207m-.545-.75-.263-.656A.25.25 0 0 0 9.14 4H6.834a.25.25 0 0 0-.234.162l-.245.65z" clipRule="evenodd" /></g><defs><clipPath id="TrashCircleFill_svg__a"><path fill="#fff" d="M3 3h10v10H3z" /></clipPath></defs></svg>;
}
;